// Copyright (c) Tangible It, Mexico. All rights reserved.
// Licensed under the MIT License.

import React from "react";

import Header from "../../components/Header/Header";

import {
  CloseIcon,
  CallVideoIcon,
  ContactGroupIcon,
  AppsIcon,
  EditIcon,
  ChevronDownIcon,
  ItalicIcon,
  PollIcon,
  VolumeIcon,
} from "@fluentui/react-icons-northstar";

import {
  Button,
  MenuButton,
  Flex,
  Dialog,
  SplitButton,
} from "@fluentui/react-northstar";

import { withTranslation } from "react-i18next";

import FeedbackControls from "./Controls/FeedbackControls";
import { Layout, Menu } from "antd";
import { Icon, IconButton } from "@fluentui/react";
import { Redirect, Route, Switch } from "react-router-dom";
import AllFeedback from "./Components/AllFeedback/AllFeedbackPage";
import ViewResponse from "./Components/ViewResponse/ViewResponse";
import Classrooms from "./Components/Classrooms/Classrooms";
import GroupHome from "./Components/Groups/GroupHome";
import SubmitFeedbackHome from "./Components/SubmitFeedback/SubmitFeedbackHome";
import { Subscription } from "../../components/Subscription/Subscription";
import FeedbackWrapper from "./Components/FeedbackFormSection/FeedbackWrapper";
import SelectedClassroom from "./Components/Classrooms/SelectedClassroom";

import "./Feedback.scss";
import "../Attendance/Attendance.css";
import moment from "moment";

const { Sider } = Layout;

const url = process.env.REACT_APP_EP_URL;

const v = new Date();
let headers;
class Feedback extends React.Component {
  constructor(props) {
    super(props);
    this.feedbackTopMenuRef = React.createRef();
    this.state = {
      onLine: null,
      load: false,
      dialog: false,
      isExpire: false,
      accDlg: false,
      isCompactMode: window.innerWidth > 667,
      selectedOption: null,
      isSubscribed: false,
      globalSearch: "",
      isSiteEmbeded: false,
      questionLimit: 10,
      audioQuestionLimit: 1,
      videoQuestionLimit: 1,
      isMobileView: window.innerWidth <= 767,
      isTabletView: window.innerWidth <= 991,
      feedbackLimitDialog: { show: false, message: "" },
      topPosition: "141px",
    };
  }

  handleResize = () => {
    this.setState({
      isMobileView: window.innerWidth <= 767,
    });
    this.setState({
      isTabletView: window.innerWidth <= 991,
    });
  };

  async componentDidMount() {
    this.updateTopPosition();
    window.addEventListener("resize", this.handleResize);
    headers = {
      Authorization: "Bearer " + this.props.user.accessToken,
    };
    const subscription = JSON.parse(localStorage.getItem("subscription"));
    if (subscription && subscription?.feedback) {
      this.setState({ isSubscribed: true, load: false });
    } else {
      this.setState({ isSubscribed: false, load: false });
    }

    if (
      this.props.user?.dbData?.subscription &&
      this.props.user?.dbData?.subscription?.feedback
    ) {
      this.setState({ isSubscribed: true, load: false });
    } else {
      this.setState({ isSubscribed: false, load: false });
    }

    if (this.props.user?.dbData?.dayRemaining <= 2) {
      if (this.props.user?.dbData?.ExpirationDate) {
        if (this.props.user?.dbData?.dayRemaining <= 0) {
          this.setState({
            ExpirationDate: this.props.user?.dbData?.ExpirationDate,
            dialog: false,
            isExpire: true,
          });
        } else {
          this.setState({
            ExpirationDate: this.props.user?.dbData?.ExpirationDate,
            dialog: true,
            isExpire: false,
          });
        }
      }
    }

    if (navigator.onLine) {
      this.setState({ onLine: navigator.onLine });
    }

    window.addEventListener("offline", (e) => {
      this.setState({ onLine: navigator.onLine });
    });

    this.setState({
      selectedOption: this.getSelectedOption(this.props.location.pathname),
    });

    const subscriptionData = this.props.user?.dbData?.subscription ?? {};

    const {
      feedbackQuestions,
      feedbackAudioQuestions,
      feedbackVideoQuestions,
    } = subscriptionData;

    this.setState({
      isSiteEmbeded: this.inIframe(),
      questionLimit: feedbackQuestions ?? 10,
      audioQuestionLimit: feedbackAudioQuestions ?? 1,
      videoQuestionLimit: feedbackVideoQuestions ?? 1,
    });

    if (window.location.pathname === "/feedback/submit-feedback/*") {
      <SubmitFeedbackHome
        {...this.props}
        {...this.state}
        isMobileView={this.state.isMobileView}
        setFeedbackLimitDialog={this.setFeedbackLimitDialog}
        selectedExtension={this.props.selectedExtension}
      />;
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  inIframe() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return false;
    }
  }

  componentDidUpdate() {
    const currentpath = this.getSelectedOption(this.props.location.pathname);
    if (this.state.selectedOption !== currentpath) {
      this.setState({
        selectedOption: currentpath,
      });
    }
  }

  updateTopPosition = () => {
    if (this.feedbackTopMenuRef.current) {
      const height =
        this.feedbackTopMenuRef.current.getBoundingClientRect().height;
      const topPosition = `calc(100vh - ${height}px)`;
      this.setState({ topPosition });
    }
  };

  getSelectedOption = (path) => {
    if (path.includes("all-feedback")) {
      return "all-feedback";
    } else if (path.includes("classrooms")) {
      return "classrooms";
    } else if (path.includes("groups")) {
      return "groups";
    } else if (path.includes("submit-feedback")) {
      return "submit-feedback";
    }
    return null;
  };

  globalSearchValueHandler = (value) => {
    this.setState({
      globalSearch: value?.length ? value.replace(/\s/g, "").toLowerCase() : "",
    });
  };

  setFeedbackLimitDialog = (value) => {
    this.setState({ feedbackLimitDialog: value });
  };

  render() {
    const { t } = this.props;

    const translation = t("feedbackModule");

    const feedbackTypesTranslation = translation.body.feedbackTypes;

    const feedbackTranslation = translation.body.mainPage;

    const { isCompactMode, feedbackLimitDialog } = this.state;

    function getItem(label, key, icon, children) {
      return {
        key,
        icon,
        children,
        label,
        "data-cy": `${key}-menu-item`,
      };
    }

    const items = [
      getItem(
        feedbackTranslation.allFeedbacks,
        "all-feedback",
        <AppsIcon outline />
      ),
      getItem(
        feedbackTranslation.classroom,
        "classrooms",
        <CallVideoIcon outline />
      ),
      getItem(
        feedbackTranslation.groups,
        "groups",
        <ContactGroupIcon outline />
      ),
      getItem(
        feedbackTranslation.giveFeedback,
        "submit-feedback",
        <EditIcon outline />
      ),
    ];

    const itemsForParents = [
      getItem(
        feedbackTranslation.giveFeedback,
        "submit-feedback",
        <EditIcon outline />
      ),
    ];

    const getFeedbackMenu = [
      {
        key: "any",
        itemValue: "Any",
        content: feedbackTypesTranslation.any,
        icon: <Icon iconName="PieSingle" />,
        "data-cy": "any-feedback-selector-btn",
      },
      {
        key: "text",
        itemValue: "Text",
        content: feedbackTypesTranslation.text,
        icon: <ItalicIcon outline />,
        "data-cy": "text-feedback-selector-btn",
      },
      {
        key: "audio",
        itemValue: "Audio",
        content: feedbackTypesTranslation.audio,
        icon: <VolumeIcon outline />,
        "data-cy": "audio-feedback-selector-btn",
      },
      {
        key: "video",
        itemValue: "Video",
        content: feedbackTypesTranslation.video,
        icon: <CallVideoIcon outline />,
        "data-cy": "video-feedback-selector-btn",
      },
      {
        key: "poll",
        itemValue: "Poll",
        content: feedbackTypesTranslation.poll,
        icon: <PollIcon outline />,
        "data-cy": "poll-feedback-selector-btn",
      },
    ];

    return (
      <div className="feedback">
        <Flex column style={{ height: "100%" }}>
          {this.props?.user?.actualRole === "SuperAdmin" ? (
            <Dialog
              open={this.state.dialog}
              onConfirm={() => this.setState({ dialog: false })}
              confirmButton={translation.common.okay}
              content={
                feedbackTranslation.plan.expire +
                (this.state.ExpirationDate
                  ? moment(this.state.ExpirationDate).format("MMMM D, YYYY")
                  : "-") +
                feedbackTranslation.plan.renew
              }
              header={feedbackTranslation.plan.header}
              headerAction={{
                icon: <CloseIcon />,
                title: translation.common.close,
                onClick: () => this.setState({ dialog: false }),
              }}
            />
          ) : null}
          <Dialog
            open={this.state.accDlg}
            onConfirm={() => location.reload()}
            confirmButton={feedbackTranslation.refreshNow}
            content={
              <p className="refreshMsg">{feedbackTranslation.refreshMsg}</p>
            }
            header={feedbackTranslation.authorizationExpire}
          />
          {/* Feedback limit reached dialog */}
          <Dialog
            open={feedbackLimitDialog.show}
            onConfirm={() =>
              this.setState({
                feedbackLimitDialog: { message: "", show: false },
              })
            }
            confirmButton={translation.common.close}
            content={feedbackLimitDialog.message}
            header={feedbackTranslation.plan.header}
            headerAction={{
              icon: <CloseIcon />,
              title: translation.common.close,
              onClick: () =>
                this.setState({
                  feedbackLimitDialog: { message: "", show: false },
                }),
            }}
          />
          <div
            style={{
              position: "sticky",
              top: 61,
              zIndex: 999,
            }}
            id="feedback-top-menu"
            ref={this.feedbackTopMenuRef}
          >
            {!this.state.isExpire &&
              this.state.isSubscribed &&
              !this.state.isSiteEmbeded && (
                <div className="s-ctr">
                  <FeedbackControls
                    state={{
                      ...this.state,
                      ...{ accessToken: this.props.user.accessToken },
                    }}
                    user={this.props.user}
                    searchValueChangeHandler={this.globalSearchValueHandler}
                    isMobileView={this.state.isMobileView}
                  />
                </div>
              )}
          </div>
          <div
            style={{
              width: "100%",
              // overflowX: "auto",
              backgroundColor: "white",
              flexGrow: 1,
            }}
          >
            {(!this.state.isSubscribed && !this.state.load) ||
            this.state.isExpire ? (
              <Subscription
                pageName="feedback"
                isExpire={this.state.isExpire}
                role={this.props.user.role}
              />
            ) : (
              <Flex
                gap="gap.medium"
                wrap
                className="container2 d-sm-center"
                fill
                column
                style={{ height: "100%" }}
              >
                <div className="feeback-table-wrapper">
                  <Flex className="feedback-wrapper">
                    {!this.state.isSiteEmbeded && (
                      <div
                        style={{
                          position: "sticky",
                          top: this.state.topPosition,
                          zIndex: 999,
                        }}
                      >
                        <Sider
                          collapsedWidth={60}
                          trigger={null}
                          theme="light"
                          collapsible
                          collapsed={isCompactMode}
                          breakpoint="sm"
                          onBreakpoint={(data, e) => {
                            this.setState({ isCompactMode: !isCompactMode });
                          }}
                          className="feedback-sider"
                        >
                          {isCompactMode &&
                            this.props.user?.role?.toLowerCase() !==
                              "parent" && (
                              <Flex hAlign="center">
                                <IconButton
                                  iconProps={{
                                    iconName: isCompactMode
                                      ? "GlobalNavButton"
                                      : "ChevronLeft",
                                    style: {
                                      fontWeight: 900,
                                      color: "#424242",
                                      background:
                                        this.state.isMobileView && "white",
                                    },
                                  }}
                                  title={feedbackTranslation.menu}
                                  ariaLabel={feedbackTranslation.menu}
                                  onClick={() =>
                                    this.setState({
                                      isCompactMode: !isCompactMode,
                                    })
                                  }
                                  style={{
                                    background:
                                      this.state.isMobileView && "white",
                                  }}
                                />
                              </Flex>
                            )}
                          {this.props.user?.role?.toLowerCase() === "parent" ? (
                            <Flex hAlign={isCompactMode ? "center" : "end"}>
                              <IconButton
                                iconProps={{
                                  iconName: isCompactMode
                                    ? "GlobalNavButton"
                                    : "ChevronLeft",
                                  style: {
                                    fontWeight: 900,
                                    color: "#424242",
                                    background:
                                      this.state.isMobileView && "white",
                                    fontSize: 14,
                                  },
                                }}
                                title={feedbackTranslation.menu}
                                ariaLabel={feedbackTranslation.menu}
                                onClick={() =>
                                  this.setState({
                                    isCompactMode: !isCompactMode,
                                  })
                                }
                                style={{
                                  background:
                                    this.state.isMobileView && "white",
                                  width: "25px",
                                }}
                              />
                            </Flex>
                          ) : (
                            <Flex
                              hAlign="center"
                              style={{
                                marginTop: !isCompactMode && "10px",
                                marginBottom: !isCompactMode && "5px",
                              }}
                            >
                              {!isCompactMode ? (
                                <>
                                  <SplitButton
                                    menu={getFeedbackMenu}
                                    title={feedbackTranslation.getfeedback}
                                    button={{
                                      content: feedbackTranslation.getfeedback,
                                      "aria-roledescription": "splitbutton",
                                      "aria-describedby":
                                        "instruction-message-primary-button",
                                      "data-cy": "get-feedback-btn",
                                      className: "create-feedback-split-button",
                                      style: {
                                        borderRadius:
                                          this.state.isMobileView && "4px",
                                      },
                                    }}
                                    primary
                                    toggleButton={{
                                      "aria-label": "more options",
                                      "data-cy": "feedback-options-toggle-btn",
                                      className:
                                        "create-feedback-toggle-button",
                                      style: {
                                        borderRadius:
                                          this.state.isMobileView && "4px",
                                      },
                                    }}
                                    onMainButtonClick={(e, data) => {
                                      this.setState({ selectedOption: "" });
                                      this.props.history.push(
                                        "/feedback/text-feedback"
                                      );
                                    }}
                                    onMenuItemClick={(e, data) => {
                                      this.setState({ selectedOption: "" });
                                      if (data.itemValue === "Text") {
                                        this.props.history.push(
                                          "/feedback/text-feedback"
                                        );
                                      } else if (data.itemValue === "Poll") {
                                        this.props.history.push(
                                          "/feedback/poll-feedback"
                                        );
                                      } else if (data.itemValue === "Any") {
                                        this.props.history.push(
                                          "/feedback/any-feedback"
                                        );
                                      } else if (data.itemValue === "Audio") {
                                        this.props.history.push(
                                          "/feedback/audio-feedback"
                                        );
                                      } else if (data.itemValue === "Video") {
                                        this.props.history.push(
                                          "/feedback/video-feedback"
                                        );
                                      }
                                    }}
                                    style={{
                                      gap: this.state.isMobileView && "5px",
                                      display:
                                        this.state.isMobileView && "flex",
                                    }}
                                  />
                                  <IconButton
                                    iconProps={{
                                      iconName: isCompactMode
                                        ? "GlobalNavButton"
                                        : "ChevronLeft",
                                      style: {
                                        fontWeight: 900,
                                        color: "#424242",
                                        background:
                                          this.state.isMobileView && "white",
                                        fontSize: 14,
                                      },
                                    }}
                                    title={feedbackTranslation.menu}
                                    ariaLabel={feedbackTranslation.menu}
                                    onClick={() =>
                                      this.setState({
                                        isCompactMode: !isCompactMode,
                                      })
                                    }
                                    style={{
                                      background:
                                        this.state.isMobileView && "white",
                                      width: "25px",
                                    }}
                                  />
                                </>
                              ) : (
                                <MenuButton
                                  trigger={
                                    <Button
                                      primary
                                      style={{
                                        width: "20px",
                                        minWidth: "30px",
                                      }}
                                      icon={<ChevronDownIcon />}
                                      title={feedbackTranslation.menu}
                                    />
                                  }
                                  onMenuItemClick={(e, data) => {
                                    if (data.itemValue === "Text") {
                                      this.setState({ selectedOption: "" });
                                      this.props.history.push(
                                        "/feedback/text-feedback"
                                      );
                                    } else if (data.itemValue === "Poll") {
                                      this.props.history.push(
                                        "/feedback/poll-feedback"
                                      );
                                    } else if (data.itemValue === "Any") {
                                      this.props.history.push(
                                        "/feedback/any-feedback"
                                      );
                                    } else if (data.itemValue === "Audio") {
                                      this.props.history.push(
                                        "/feedback/audio-feedback"
                                      );
                                    } else if (data.itemValue === "Video") {
                                      this.props.history.push(
                                        "/feedback/video-feedback"
                                      );
                                    }
                                  }}
                                  menu={getFeedbackMenu}
                                />
                              )}
                            </Flex>
                          )}
                          <Menu
                            theme="light"
                            style={{ height: "calc(100% - 50px)" }}
                            defaultSelectedKeys={null}
                            selectedKeys={this.state.selectedOption}
                            mode="inline"
                            multiple={false}
                            items={
                              this.props.user?.role?.toLowerCase() === "parent"
                                ? itemsForParents
                                : this.props.user?.role?.toLowerCase() !==
                                  "student"
                                ? items
                                : items.filter(
                                    (item) => item.key !== "classrooms"
                                  )
                            }
                            onClick={(data) => {
                              data.domEvent.preventDefault();
                              this.setState({ selectedOption: data.key });
                              if (data.key === "all-feedback") {
                                this.props.history.push(
                                  "/feedback/all-feedback"
                                );
                              } else if (data.key === "classrooms") {
                                this.props.history.push("/feedback/classrooms");
                              } else if (data.key === "groups") {
                                this.props.history.push("/feedback/groups");
                              } else if (data.key === "submit-feedback") {
                                this.props.history.push(
                                  "/feedback/submit-feedback"
                                );
                              }
                            }}
                          />
                        </Sider>
                      </div>
                    )}
                    <Flex
                      className={`feedback-section ${
                        isCompactMode ? "compact-mode" : ""
                      }`}
                      wrap
                      fill
                      style={{
                        paddingBottom: "20px",
                      }}
                    >
                      <div
                        className="feedback-sections"
                        style={{ width: "100%" }}
                      >
                        <Switch>
                          <Route path="/feedback/all-feedback">
                            <AllFeedback
                              {...this.props}
                              {...this.state}
                              isMobileView={this.state.isMobileView}
                              setFeedbackLimitDialog={
                                this.setFeedbackLimitDialog
                              }
                              isTabletView={this.state.isTabletView}
                            />
                          </Route>
                          {this.props.user?.role?.toLowerCase() !==
                            "student" && (
                            <Route exact path="/feedback/classrooms">
                              <Classrooms {...this.props} {...this.state} />
                            </Route>
                          )}
                          {this.props.user?.role?.toLowerCase() !==
                            "student" && (
                            <Route
                              exact
                              path="/feedback/classrooms/:classroomId"
                            >
                              <SelectedClassroom
                                {...this.props}
                                {...this.state}
                              />
                            </Route>
                          )}
                          <Route path="/feedback/groups">
                            <GroupHome {...this.props} {...this.state} />
                          </Route>
                          <Route exact path="/feedback/text-feedback">
                            <FeedbackWrapper
                              {...this.props}
                              {...this.state}
                              type={"TEXT"}
                              key={"TEXT"}
                              setFeedbackLimitDialog={
                                this.setFeedbackLimitDialog
                              }
                            />
                          </Route>
                          <Route exact path="/feedback/audio-feedback">
                            <FeedbackWrapper
                              {...this.props}
                              {...this.state}
                              type={"AUDIO"}
                              key={"AUDIO"}
                              setFeedbackLimitDialog={
                                this.setFeedbackLimitDialog
                              }
                            />
                          </Route>
                          <Route exact path="/feedback/video-feedback">
                            <FeedbackWrapper
                              {...this.props}
                              {...this.state}
                              type={"VIDEO"}
                              key={"VIDEO"}
                              setFeedbackLimitDialog={
                                this.setFeedbackLimitDialog
                              }
                            />
                          </Route>
                          <Route exact path="/feedback/any-feedback">
                            <FeedbackWrapper
                              {...this.props}
                              {...this.state}
                              type={"ANY"}
                              key={"ANY"}
                              setFeedbackLimitDialog={
                                this.setFeedbackLimitDialog
                              }
                            />
                          </Route>
                          <Route exact path="/feedback/poll-feedback">
                            <FeedbackWrapper
                              {...this.props}
                              {...this.state}
                              type={"POLL"}
                              key={"POLL"}
                              setFeedbackLimitDialog={
                                this.setFeedbackLimitDialog
                              }
                            />
                          </Route>
                          <Route path="/feedback/submit-feedback">
                            <SubmitFeedbackHome
                              {...this.props}
                              {...this.state}
                              isMobileView={this.state.isMobileView}
                              setFeedbackLimitDialog={
                                this.setFeedbackLimitDialog
                              }
                              selectedExtension={this.props.selectedExtension}
                            />
                          </Route>
                          <Route
                            exact
                            path="/feedback/:feedbackId/view-response"
                          >
                            <ViewResponse {...this.props} {...this.state} />
                          </Route>

                          <Route path="/*">
                            <Redirect to="/feedback/all-feedback" />
                          </Route>
                        </Switch>
                      </div>
                    </Flex>
                  </Flex>
                </div>
              </Flex>
            )}
          </div>
        </Flex>
      </div>
    );
  }
}
export default withTranslation()(Feedback);
